import ReactGA from "react-ga";

export const initGA = () => {
  ReactGA.initialize("UA-180150246-1");
}

export const GApageView = () => {   
  ReactGA.pageview(window.location.pathname + window.location.search);
}